module.exports = "<app-top-menu></app-top-menu>\n\n<app-banner-header *ngIf=\"isHomePage\"></app-banner-header>\n"